﻿import ReactDOM from 'react-dom/client';
import './scss/style.scss';
import App from './App';
import { QueryClient, QueryClientProvider } from 'react-query';
import MsalWrapper from './auth/MsalWrapper';

declare global {
    interface Window {
        faqbot?: {
            open: () => void;
            askQuestion: (questionText: string) => void;
            setContext: (context: Record<string, string>) => void;
        };
    }
}

const root = ReactDOM.createRoot(document.getElementById('root')!);

const queryClient = new QueryClient();

root.render(
    <QueryClientProvider client={queryClient}>
        <MsalWrapper>
            <App />
        </MsalWrapper>
    </QueryClientProvider>
);
